import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellation-report',
  templateUrl: './cancellation-report.component.html',
  styleUrls: ['./cancellation-report.component.scss']
})
export class CancellationReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
